import { IFtndResponse } from 'src/@types/apiResponse';
import {
  IDrugQuestion,
  IDrugQuestionComplete,
  IFtnd,
  IMedicalQuestion,
  IMedicalQuestionComplete,
  IMedicalQuestionResult,
} from 'src/models';
import { IDrugQstAnswer, IFtndAnswer } from 'src/screens';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 니코틴 의존도 평가 조회 */
export const getFtnd = async () => {
  try {
    const url = `/ftnd`;

    const response = await instance.get<TApiResponseData<IFtnd[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 니코틴 의존도 평가 */
export const setFtndResult = async (answers: IFtndAnswer[]) => {
  try {
    const url = `/userFtndResult`;

    const response = await instance.post<TApiResponseData<IFtndResponse>>(url, answers);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 문진 */
export const getMedicalQuestions = async (medicalQuestionTypeCd: number) => {
  try {
    const url = `/medicalQuestion/${medicalQuestionTypeCd}`;

    const response = await instance.get<TApiResponseData<IMedicalQuestion[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 문진 응답 */
export const setMedicalQuestionsResult = async (
  medicalQuestionResult: IMedicalQuestionResult[],
) => {
  try {
    const url = `/userMedicalQuestionResult`;

    const response = await instance.post<TApiResponseData<IMedicalQuestionComplete[]>>(
      url,
      medicalQuestionResult,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 문진 완료 여부 조회 */
export const getMediQuestionCompleteStatus = async () => {
  try {
    const url = `/userMedicalQuestionResult/complete/status`;

    const response = await instance.get<TApiResponseData<IMedicalQuestionComplete[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 문진 완료 여부 조회 */
export const getDrugQuestionCompleteStatus = async () => {
  try {
    const url = `/userDrugQuestionResult/complete/status`;

    const response = await instance.get<TApiResponseData<IDrugQuestionComplete[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 문진 조회 */
export const getDrugQuestion = async (drugQstTypeCd: number) => {
  try {
    const url = `/drugQuestion/${drugQstTypeCd}`;

    const response = await instance.get<TApiResponseData<IDrugQuestion[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 문진 답변 */
export const setDrugQuestion = async (drugQuestionAnswers: IDrugQstAnswer[]) => {
  try {
    const url = `/userDrugQuestionResult`;

    const response = await instance.post<TApiResponseData<IDrugQuestionComplete[]>>(
      url,
      drugQuestionAnswers,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
